



































import Vue from 'vue'
import { carAgencyController } from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import ImagePicker from '~/components/ImagePicker.vue'
import PhoneTextField from '~/components/PhoneTextField.vue'
import { TableHeader } from '~/utils/interfaces'
import { CarAgency } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: { AppView, PhoneTextField, ImagePicker },
  data() {
    return {
      controller: carAgencyController,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('email'),
          value: 'email',
        },
        {
          text: this.$t('phone'),
          value: 'phone',
        },
        {
          text: this.$t('address'),
          value: 'address',
        },
        {
          text: this.$t('is_active'),
          value: 'is_active',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<CarAgency>[],
      defaultCrud: {
        name: '',
        email: '',
        phone: '',
        address: '',
        image: null,
      },
    }
  },
})
